import { axiosInstance, axiosInstanceNotAuthorized } from './axiosInstance';
import { clearLocalStorage } from '../utils';

export const authUser = (username, password, telegramId) =>
    axiosInstanceNotAuthorized.post(
        `/auth/login/`,
        {
            username: username,
            password: password,
            telegramId: telegramId,
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );

export const authTelegramUser = (telegram_id) =>
    axiosInstanceNotAuthorized.post(
        `/auth/telegram/login/`,
        {
            telegram_id: telegram_id,
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );

export const registerUser = (userData) =>
    axiosInstanceNotAuthorized.post(
        `/auth/telegram/register/`,
        {
            ...userData,
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );

export const getUserData = async (userId, teamId = null, isTrialEndPage = false) => {
    const options = { params: {} };

    if (userId && typeof userId === 'number') {
        options.params.user_id = userId;
    }

    if (teamId) {
        options.params.team_id = teamId;
        
    } else {
        const teamId = localStorage.getItem('team-id');
        options.params.team_id = teamId;
    }

    return axiosInstance
        .get('auth/current_user/', options)
        .then(({ data }) => {
            if (data?.is_access_finished && !isTrialEndPage && !data.app_admin_panel) {
                window.location.href = '/trial-end';
            }

            if (!data) {
                console.error('Ошибка /current_user/. Нет данных о пользователе');
                return {};
            }

            return {
                userId: data.id,
                username: data.username,
                firstName: data.first_name,
                lastName: data.last_name,
                avatar: data.avatar,

                teamId: data.team.id,
                teamName: data.team.name,
                team: data.team,

                session: data.session,
                values: data.values,

                isLeader: data.app_admin_panel,
                isAccessFinished: data.is_access_finished,
                language: data.language,

                areValuesApproved: data.team.are_values_approved,
                isSessionCreated: data.team.is_session_created,
                numbersOfUsers: data.team.number_of_users,
                currentUsersNumber: data.team.current_users_number,
                avaliableSteps: data.team.avaliable_steps,
                currentUserNumber: data.team.current_users_number,
                allUserNumber: data.team.number_of_users,

                isTeamMember: data.is_team_member
            };
        })
        .catch(({ response }) => {
            if (response.data.code === 'user_not_found') {
                clearLocalStorage();
                return null;
            }
        });
};
